module.exports = __webpack_public_path__ + "static/media/choose-image-dark.4978c534.svg";